import { connect, injectSaga } from '@vfde-fe/sails_core';
import { NAMESPACE } from './constant';
import { createStructuredSelector } from 'reselect';
import saga from './saga';
import { goToBasket } from './action';
import mountOfferPrice, { updateAdditionalLinks, updateDevicePriceText, updateOfferPrice } from '../../components/offerPrice';
import { selectError, selectSalesChannel, selectSelectedOption, selectTariffs } from 'Container/App/selector';
import { reinitFootnotes } from '../../components/footnotes';

const mapStateToProps = createStructuredSelector({
    error: selectError,
    salesChannel: selectSalesChannel,
    selectedOption: selectSelectedOption,
    tariffs: selectTariffs,
});

const mapDispatch = {
    goToBasket,
};

type State = ReturnType<typeof mapStateToProps>;
type Actions = typeof mapDispatch;

function priceSectionContainer (state: State, actions: Actions) {
    injectSaga(NAMESPACE, saga);

    const offerPriceComponent = mountOfferPrice(actions.goToBasket);

    return {
        getDerivedStateFromProps (newState: State, oldState: State) {
            if (newState.error) {
                return;
            }

            const selected = newState.selectedOption;
            const salesChanged = newState.salesChannel !== oldState.salesChannel;
            const tariffChanged = selected.subscriptionId !== oldState.selectedOption.subscriptionId;
            const hardwareChanged = selected.hardwareId !== oldState.selectedOption.hardwareId;
            const subscriptionsChanged = newState.tariffs !== oldState.tariffs;
            const selectedChanged = newState.selectedOption !== oldState.selectedOption;
            const shouldUpdateOfferPrice = (tariffChanged || salesChanged || hardwareChanged || subscriptionsChanged);

            shouldUpdateOfferPrice && updateOfferPrice(offerPriceComponent, selected, newState.salesChannel);
            selectedChanged && updateDevicePriceText(offerPriceComponent.stairwayComponent, selected);
            selectedChanged && updateAdditionalLinks(selected.subscriptionId);
            shouldUpdateOfferPrice && reinitFootnotes();
        },
    };
}

const priceSection = connect(mapStateToProps, mapDispatch)(priceSectionContainer);

export default priceSection;
